import {Button, Pagination, Tooltip} from 'antd';
import { Table, Switch, Space } from 'antd';
import {useEffect, useState} from "react";
import {v4} from "uuid";
import {useDataGrid} from "./DataGridContext";
import {useTranslation} from "react-i18next";
import {ReloadOutlined} from "@ant-design/icons";

const SORT = {
    NONE: -1,
    ASC: 0,
    DESC: 1
}

export const RenderableExpandRow = ({children, expanded, recordId}) => {

    const {t} = useTranslation();
    const {renderItem, renderExpandedRow} = useDataGrid()
    const [item, setItem] = useState('');

    useEffect(() => {
        if(renderItem && renderItem.recordId === recordId)
        {
            setItem(renderItem)
        }
    }, [renderItem])

    return (
        <>
            {
                expanded && (
                    <div key={item.key}>
                        <Tooltip placement={'bottomLeft'} title={t('Refresh')}>
                            <Button onClick={() => {renderExpandedRow(recordId)}}>
                                <ReloadOutlined />
                            </Button>
                        </Tooltip>
                        {children}
                    </div>
                )
            }
        </>
    )
}

export default function DataGrid({})
{
    const {resultModel, dataGridProps, setSelectedRows, onPaginationAndSort, tableId, selectedRows} = useDataGrid()
    const [rowSelection, setRowSelection] = useState({
        selectedRowKeys: selectedRows.map(x => x[dataGridProps.rowKey || 'id']),
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRows(selectedRows)
        },
        onSelect: (record, selected, selectedRows) => {

        },
        onSelectAll: (selected, selectedRows, changeRows) => {
        }
    })

    useEffect(() => {
        if(selectedRows)
        {
            setRowSelection({
                ...rowSelection,
                selectedRowKeys: selectedRows.map(x => x[dataGridProps.rowKey || 'id']),
            })
        }
    }, [selectedRows])

    const getSortType = (sort) => {
        if(!sort)
            return SORT.NONE;
        else if(sort === 'ascend')
            return SORT.ASC
        else
            return SORT.DESC
    }

    const onChange = (pagination, filters, sorter) => {
        const col = dataGridProps.columns.find(x => x.key === sorter.field);

        const paginationQuery = {
            pageNumber: pagination.current,
                pageSize: pagination.pageSize
        };

        const orderByItems = !col ? [] : [
            {
                name: col.columnName || sorter.field,
                operation: getSortType(sorter.order)
            }
        ];

        onPaginationAndSort(paginationQuery, orderByItems)
    }

    return (
        <>
            <Table
                size={'small'}
                scroll={{x: 1280}}
                rowKey={dataGridProps.rowKey || 'id'}
                columns={dataGridProps.columns}
                rowSelection={rowSelection && dataGridProps.enableRowSelection}
                dataSource={resultModel.data}
                onChange={onChange}
                expandable={{
                    expandedRowRender: dataGridProps.expandedRowRender,
                    rowExpandable: dataGridProps.rowExpandable,
                    //expandedRowKeys: expandedRowKeys,
                }}
                rowClassName={dataGridProps.rowClassName}
                onRow={dataGridProps.onRow}
                id={tableId}
                pagination={{
                    total: resultModel?.pagination?.totalRecords || 0,
                    pageSize: resultModel.pagination?.pageSize || 20,
                    size: 'small',
                    current: resultModel.pagination?.pageNumber || 1,
                    showTotal:total => `Total ${total} records`,
                    showSizeChanger: true
                }}
            />
        </>
    )
}
